function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { Button, USPhoneNumberInput } from 'seagull';
import { usPhoneNumberValidation } from 'validators';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { StepTemplate } from "../StepTemplate";
import { Step } from "../VendorOnboardingModal.utils";
import PostalAddressForm from "../../PostalAddressForm/PostalAddressForm";
import styles from "./SecondStep.module.scss";
import { useQboInVob } from "../useQboInVob";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SecondStep(props) {
  var _initialState$postalA, _initialState$postalA2, _initialState$postalA3, _initialState$postalA4, _initialState$postalA5, _initialState$postalA6;
  const {
    initialState,
    onSubmit
  } = props;
  const defaultPostalAddress = {
    address1: (initialState === null || initialState === void 0 || (_initialState$postalA = initialState.postalAddress) === null || _initialState$postalA === void 0 ? void 0 : _initialState$postalA.address1) || '',
    address2: (initialState === null || initialState === void 0 || (_initialState$postalA2 = initialState.postalAddress) === null || _initialState$postalA2 === void 0 ? void 0 : _initialState$postalA2.address2) || '',
    city: (initialState === null || initialState === void 0 || (_initialState$postalA3 = initialState.postalAddress) === null || _initialState$postalA3 === void 0 ? void 0 : _initialState$postalA3.city) || '',
    state: (initialState === null || initialState === void 0 || (_initialState$postalA4 = initialState.postalAddress) === null || _initialState$postalA4 === void 0 ? void 0 : _initialState$postalA4.state) || '',
    postalCode: (initialState === null || initialState === void 0 || (_initialState$postalA5 = initialState.postalAddress) === null || _initialState$postalA5 === void 0 ? void 0 : _initialState$postalA5.postalCode) || '',
    country: (initialState === null || initialState === void 0 || (_initialState$postalA6 = initialState.postalAddress) === null || _initialState$postalA6 === void 0 ? void 0 : _initialState$postalA6.country) || 'US'
  };
  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      postalAddress: defaultPostalAddress,
      phone: (initialState === null || initialState === void 0 ? void 0 : initialState.phone) || ''
    }
  });
  const {
    showQboStep
  } = useQboInVob();
  return /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
    children: /*#__PURE__*/_jsx("form", {
      onSubmit: methods.handleSubmit(onSubmit),
      children: /*#__PURE__*/_jsx(StepTemplate, {
        currentStep: Step.Second,
        stepper: "Step 2 of ".concat(showQboStep ? '3' : '2'),
        header: "What\u2019s your business address?",
        subHeader: "To ensure smooth payments, please add your business address",
        footer: /*#__PURE__*/_jsx(Button, {
          "data-testid": "vob-step-".concat(Step.Second, "-submit"),
          type: "submit",
          children: showQboStep ? 'Continue' : 'Take me to my account'
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.root,
          children: [/*#__PURE__*/_jsx(Controller, {
            control: methods.control,
            name: "postalAddress",
            render: _renderProps => /*#__PURE__*/_jsx(PostalAddressForm, {
              testid: "vob"
            })
          }), /*#__PURE__*/_jsx(Controller, {
            control: methods.control,
            name: "phone",
            rules: usPhoneNumberValidation({
              required: 'Please enter a phone number'
            }),
            render: renderProps => /*#__PURE__*/_jsx(USPhoneNumberInput, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
              "data-testid": "vob-phone",
              label: "Your phone number"
            }))
          })]
        })
      })
    })
  }));
}